<button
  type="button"
  class="ut-btn ut-btn--secondary ut-btn--sm hide-action"
  [class.is-on]="hidden"
  [class.is-loading]="state.loading()"
  [class.anim-on]="state.animation() === 'on'"
  [class.anim-off]="state.animation() === 'off'"
  [attr.aria-label]="label"
  [attr.aria-busy]="state.busy()"
  [class.hover-locked]="state.hoverLocked()"
  (mouseleave)="state.unlockHover()"
  (click)="confirm()">
  <svg class="hide-action__eye" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
    <path class="hide-action__slash" d="M2 2l20 20"/>
  </svg>
  <span class="action__slot">
    <span class="action__idle" [class.is-shown]="!hidden">Hide</span>
    <span class="action__done" [class.is-shown]="hidden">
      <span class="action__rest">Hidden</span>
      <span class="action__hover">Show</span>
    </span>
  </span>
</button>
<span class="sr-only" aria-live="polite">{{ state.announcement() }}</span>
